import gql from 'graphql-tag';

export const TEAM_ACTIVITY = gql`
  fragment teamActivity on TeamActivity {
    latestCompletedVisit {
      start
      status
      scheduleChangeReason
      scheduleChangeNotes
      type
      subType
    }
    latestMissedVisit {
      start
      status
      scheduleChangeReason
      scheduleChangeNotes
      type
      subType
    }
    nextVisit {
      start
      type
      subType
    }
  }
`;
